export default __webpack_public_path__ + "static/media/p1050315.5cb74761-min.c79e0b3d.jpg";